import {
  EducationLevelType,
  LegalClientFinancialInstrumentType,
} from 'api/types/entity';
import { getYesOrNoOptions, isYes } from 'helpers';
import { useTranslation } from 'libs/i18n';

import {
  Field,
  useFormContext,
} from '../../../forms/knowledgeAndExperienceForm';

export const FormContent = () => {
  const { t } = useTranslation();

  const { values } = useFormContext();

  const isOtherFinancialInstrument = values.financialInstruments?.some(
    (v) => v?.value === LegalClientFinancialInstrumentType.Other
  );

  return (
    <>
      <Field.Autocomplete
        multiple
        showOptionalMark
        label={t(
          'onboarding.legalKnowledgeAndExperience.financialInstruments.label'
        )}
        name="financialInstruments"
        options={Object.values(LegalClientFinancialInstrumentType)?.map(
          (v) => ({
            label: t(
              `onboarding.legalKnowledgeAndExperience.financialInstruments.types.${v}`
            ),
            value: v,
          })
        )}
        placeholder={t('common.chooseAnOption')}
      />
      {isOtherFinancialInstrument && (
        <Field.Text
          label={t(
            'onboarding.legalKnowledgeAndExperience.otherFinancialInstrument.label'
          )}
          name="otherFinancialInstrument"
          placeholder={t(
            'onboarding.legalKnowledgeAndExperience.otherFinancialInstrument.placeholder'
          )}
        />
      )}

      <Field.Autocomplete
        label={t(
          'onboarding.legalKnowledgeAndExperience.hasQualifiedOfficersForInvestmentDecisions.label'
        )}
        name="hasQualifiedOfficersForInvestmentDecisions"
        options={getYesOrNoOptions(t)}
        placeholder={t('common.chooseAnOption')}
      />

      {isYes(values.hasQualifiedOfficersForInvestmentDecisions) && (
        <>
          <Field.Autocomplete
            label={t(
              'onboarding.legalKnowledgeAndExperience.educationLevel.label'
            )}
            name="educationLevel"
            options={Object.values(EducationLevelType).map((v) => ({
              label: t(
                `onboarding.knowledgeAndExperience.education.types.${v}`
              ),
              value: v,
            }))}
            placeholder={t('common.chooseAnOption')}
          />
          <Field.Autocomplete
            label={t(
              'onboarding.legalKnowledgeAndExperience.heldFinancialPositionInLast5Years.label'
            )}
            name="heldFinancialPositionInLast5Years"
            options={getYesOrNoOptions(t)}
            placeholder={t('common.chooseAnOption')}
          />
        </>
      )}
    </>
  );
};
